<template>
    <el-card shadow="hover" class="similar-image-review-card">
        <div class="similar-image-review-card__header">
            <div>
                <div class="similar-image-review-card__title">核验记录 #{{ record.reviewRecordId || "-" }}</div>
                <div class="similar-image-review-card__meta">
                    <span>来源案件号：{{ record.sourceCaseNo || "-" }}</span>
                    <span>候选案件号：{{ record.targetCaseNo || "-" }}</span>
                    <span>相似度：{{ similarityText }}</span>
                </div>
                <div class="similar-image-review-card__meta similar-image-review-card__meta--llm">
                    <span>一级分类：{{ record.llmCategoryLevel1 || "-" }}</span>
                    <span>二级分类：{{ record.llmCategoryLevel2 || "-" }}</span>
                    <span>分类状态：{{ llmStatusLabel }}</span>
                </div>
            </div>
            <el-tag size="mini" :type="reviewStatusType">{{ statusLabel }}</el-tag>
        </div>
        <div class="similar-image-review-card__body">
            <div class="similar-image-review-card__images">
                <div class="similar-image-review-card__image-box">
                    <div class="similar-image-review-card__image-title">来源图</div>
                    <button
                        v-if="record.sourceImageUrl"
                        type="button"
                        class="similar-image-review-card__image-trigger"
                        @click="$emit('open-source-image', record)"
                    >
                        <img
                            :src="record.sourceImageUrl"
                            class="similar-image-review-card__image"
                            loading="lazy"
                        />
                    </button>
                    <div v-else class="similar-image-review-card__placeholder">来源图不可用</div>
                </div>
                <div class="similar-image-review-card__image-box">
                    <div class="similar-image-review-card__image-title">候选图</div>
                    <button
                        v-if="record.targetImageUrl"
                        type="button"
                        class="similar-image-review-card__image-trigger"
                        @click="$emit('open-target-image', record)"
                    >
                        <img
                            :src="record.targetImageUrl"
                            class="similar-image-review-card__image"
                            loading="lazy"
                        />
                    </button>
                    <div v-else class="similar-image-review-card__placeholder">候选图不可用</div>
                </div>
            </div>
            <div class="similar-image-review-card__side">
                <div class="similar-image-review-card__context">{{ record.contextSummary || "暂无上下文摘要" }}</div>
                <slot name="actions" />
            </div>
        </div>
    </el-card>
</template>

<script>
export default {
    name: "SimilarImageReviewCard",
    props: {
        record: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    computed: {
        reviewStatusType() {
            switch (this.record.reviewStatus) {
                case "confirmed-valid":
                    return "success";
                case "confirmed-rejected":
                    return "info";
                default:
                    return "warning";
            }
        },
        statusLabel() {
            switch (this.record.reviewStatus) {
                case "confirmed-valid":
                    return "确认有效";
                case "confirmed-rejected":
                    return "确认排除";
                default:
                    return "待定";
            }
        },
        similarityText() {
            const value = Number(this.record.similarityScore || 0);
            return value ? value.toFixed(4) : "-";
        },
        llmStatusLabel() {
            switch (this.record.llmStatus) {
                case "success":
                    return "已分类";
                case "failed":
                    return this.record.llmErrorCode ? `失败(${this.record.llmErrorCode})` : "失败";
                default:
                    return "待分类";
            }
        },
    },
};
</script>

<style scoped>
.similar-image-review-card {
    border-radius: 14px;
}

.similar-image-review-card__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 16px;
}

.similar-image-review-card__title {
    font-size: 16px;
    font-weight: 600;
    color: #1f2d3d;
}

.similar-image-review-card__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 8px;
    color: #606266;
    font-size: 13px;
}

.similar-image-review-card__meta--llm {
    color: #7a5c18;
}

.similar-image-review-card__body {
    display: grid;
    grid-template-columns: minmax(0, 1.5fr) minmax(280px, 1fr);
    gap: 16px;
}

.similar-image-review-card__images {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
}

.similar-image-review-card__image-box {
    background: #f7f9fc;
    border: 1px solid #e4eaf3;
    border-radius: 12px;
    padding: 12px;
}

.similar-image-review-card__image-title {
    margin-bottom: 10px;
    color: #4f5d75;
    font-size: 13px;
}

.similar-image-review-card__image-trigger {
    display: block;
    width: 100%;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
}

.similar-image-review-card__image {
    display: block;
    width: 100%;
    height: 220px;
    object-fit: contain;
    background: #fff;
    border-radius: 10px;
}

.similar-image-review-card__placeholder {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 220px;
    color: #909399;
    background: #fff;
    border-radius: 10px;
}

.similar-image-review-card__side {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.similar-image-review-card__context {
    min-height: 120px;
    padding: 14px;
    color: #3c4a5d;
    line-height: 1.7;
    background: linear-gradient(180deg, #fffdf6 0%, #fff 100%);
    border: 1px solid #f2e5b9;
    border-radius: 12px;
}

@media (max-width: 1024px) {
    .similar-image-review-card__body {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 768px) {
    .similar-image-review-card__images {
        grid-template-columns: 1fr;
    }
}
</style>
